import React from "react";

import { Image } from "../../../image";
import { Button } from "../../../button";
import { FormattedMessage } from "react-intl";
import { GameName } from "inbox-contentful";

const showMoreButtonVariantByGame: Partial<Record<GameName, string>> = {
    clashofclans: "green",
};

const showMoreButtonVariant =
    showMoreButtonVariantByGame[window.GAMENAME as GameName];

function prettyNumber(x: number | string) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const getLootrunnersClassname = (value: string | number) => {
    const vietnamese = "ảãạăắằẳẵặấầẩẫậđẻẹếềểễệỉịỏọôốồổỗộơớờởỡợủụưứừửữựỷỵ";
    const chineseRegex =
        /[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FD5\uF900-\uFA6D\uFA70-\uFAD9]/;
    const japaneseRegex = /[\u3040-\u309F\u30A0-\u30FF]/;
    const koreanRegex = /[\uAC00-\uD7AF\u1100-\u11FF]/;

    if (typeof value === "number") {
        return "";
    }

    const nameCharacters = value.split("");

    const isVietnamese = nameCharacters.some((x) =>
        vietnamese.includes(x.toLowerCase()),
    );
    if (isVietnamese) {
        return "vietnamese";
    }

    const isJapanese = nameCharacters.some((x) => japaneseRegex.test(x));
    if (isJapanese) {
        return "japanese";
    }

    const isKorean = nameCharacters.some((x) => koreanRegex.test(x));
    if (isKorean) {
        return "korean";
    }

    const isChinese = nameCharacters.some((x) => chineseRegex.test(x));
    if (isChinese) {
        return "chinese";
    }

    return "";
};

export const BlockLeaderboard = ({
    title,
    data,
    configuration,
    campaignId,
}: InboxArticleLeaderboardBlock) => {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const defaultRows = configuration.defaultRows ?? 10;
    const maximumRows = configuration.maximumRows ?? 100;

    return (
        <div className={`block-leaderboard`}>
            {campaignId === "lootrunners" ? (
                <div className="leaderboard-title">
                    <div className="leaderboard-title-image"></div>
                    <div className="leaderboard-title-text">
                        <h1>{title}</h1>
                        <h2>
                            <FormattedMessage id="globalText.leaderboardUpdatedEvery30Minutes" />
                        </h2>
                    </div>
                    <div className="leaderboard-title-prizes">
                        <div className="leaderboard-title-prizes-text">
                            <h2>Top 50</h2>
                            <h3>300</h3>
                        </div>
                        <div className="leaderboard-title-prizes-image"></div>
                    </div>
                </div>
            ) : (
                <div className={`leaderboard-title`} data-title={title}>
                    {title}
                </div>
            )}
            <div className="leaderboard-table">
                {/* TODO: header row */}
                {data
                    .slice(0, isExpanded ? maximumRows : defaultRows)
                    .map((row, rowIndex) => {
                        return (
                            <div
                                key={rowIndex}
                                className={`leaderboard-row-wrapper`}
                            >
                                <div className={`leaderboard-row`}>
                                    {configuration.useRankColumn && (
                                        <div
                                            className={`leaderboard-column rank-column`}
                                        >
                                            <span className={`text-content`}>
                                                {rowIndex + 1}
                                            </span>
                                        </div>
                                    )}
                                    {configuration.columns.map(
                                        (column, columnIndex) => (
                                            <div
                                                key={column.id}
                                                className={`leaderboard-column column-${column.title.replace(/\s+/g, "-").toLowerCase()} ${columnIndex === 0 ? getLootrunnersClassname(row[columnIndex]) : ""}`}
                                                style={{
                                                    color: column.color,
                                                }}
                                            >
                                                {campaignId === "lootrunners" &&
                                                    columnIndex === 2 && (
                                                        <>
                                                            <span className="loot-collected">
                                                                <FormattedMessage id="globalText.lootCollected" />
                                                            </span>
                                                            <br />
                                                        </>
                                                    )}
                                                <span
                                                    className={`text-content`}
                                                >
                                                    {typeof row[columnIndex] ===
                                                    "number"
                                                        ? prettyNumber(
                                                              row[columnIndex],
                                                          )
                                                        : row[columnIndex]}
                                                </span>
                                                {column.image && (
                                                    <Image
                                                        sources={column.image}
                                                    />
                                                )}
                                                {columnIndex === 0 &&
                                                    campaignId ===
                                                        "lootrunners" && (
                                                        <>
                                                            <br />
                                                            <span
                                                                className={`column-clan-special ${getLootrunnersClassname(
                                                                    row[
                                                                        columnIndex +
                                                                            1
                                                                    ],
                                                                )}`}
                                                            >
                                                                {
                                                                    row[
                                                                        columnIndex +
                                                                            1
                                                                    ]
                                                                }
                                                            </span>
                                                        </>
                                                    )}
                                            </div>
                                        ),
                                    )}
                                </div>
                            </div>
                        );
                    })}
            </div>
            {!isExpanded && data.length > (configuration.defaultRows ?? 10) && (
                <div className="show-more-button">
                    <Button
                        variant={showMoreButtonVariant}
                        onClick={() => setIsExpanded(true)}
                    >
                        <span className="buttonTextWrapper">
                            <FormattedMessage id="globalText.langLoadMore" />
                        </span>
                    </Button>
                </div>
            )}
        </div>
    );
};
